import React from "react";
import { fontsName } from "../../assets/fonts/fontsName";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "../RequestUrl";

const FOOTER = gql`
  {
    getWebsiteFooter {
      _id
      pictureLink
      description
      address
      socialLinks
      phoneNumbers
    }
  }
`;

const SidebarAbout = ({ aboutUsInfo }) => {
  const [footerInfo, setFooterInfo] = React.useState({});

  React.useEffect(() => {
    request(REQUEST_URL, FOOTER).then((data) => {
      setFooterInfo(data.getWebsiteFooter);
    });
  }, []);

  return (
    <div className="case-studies-sidebar-sticky" dir="rtl">
      <div className="case-studies-details-info" dir="rtl">
        <ul style={{ direction: "rtl", textAlign: "right" }}>
          <li style={{ fontFamily: fontsName.Vazir }}>
            <div className="icon">
              <i className="bx bx-user-pin"></i>
            </div>
            <span>مدرسه:</span>
            {aboutUsInfo && aboutUsInfo.schoolName}
          </li>
          <li style={{ fontFamily: fontsName.Vazir }}>
            <div className="icon">
              <i className="bx bx-map"></i>
            </div>
            <span>موقعیت مکانی:</span>
            {footerInfo && footerInfo.address}
          </li>

          <li style={{ fontFamily: fontsName.Vazir }}>
            <div className="icon">
              <i className="bx bx-check"></i>
            </div>
            <span>شماره تماس:</span>
            {footerInfo &&
              footerInfo.phoneNumbers &&
              footerInfo.phoneNumbers.length > 0 &&
              footerInfo.phoneNumbers.map((call, index) => (
                <p style={{ fontFamily: fontsName.Vazir }}>{call}</p>
              ))}
          </li>
          <li style={{ fontFamily: fontsName.Vazir }}>
            <div className="icon">
              <i className="bx bx-globe"></i>
            </div>
            <span>سامانه آموزشی مدرسه:</span>
            <a
              href={
                typeof window !== "undefined" &&
                `${window.location.protocol}//${window.location.hostname}/login`
              }
              target="_blank"
              rel="noreferrer"
            >
              {typeof window !== "undefined" && window.location.hostname}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SidebarAbout;
